<template>
  <!-- 轮播广告 -->
  <swiper v-if="data && showType == 3" :options="{ autoplay: true }">
    <swiper-slide v-for="(item, i) in randomItems(list)" :key="i" >
      <iframe
      class="kjwt-item"
        :data-space="item.speaceId" :data-material="item.id" :id="`kjwt-item-${item.speaceId}-${item.id}`"
        frameborder="0"
        scrolling="no"
        :src="`/crm/inventory/get/${item.id}`"
        v-if="item.type == 3"
        :style="{ width: `${item.width}px`, height: `${item.height}px` }"
      ></iframe>
      <a class="kjwt-item" :href="item.url" target="_blank" :data-space="item.speaceId" :data-material="item.id" :id="`kjwt-item-${item.speaceId}-${item.id}`" rel="sponsored" v-else>
        <img class="kjwt-image" :src="item.imgSrc" />
      </a>
    </swiper-slide>
  </swiper>

  <!-- 图片广告（独显、轮显） -->
  <a :id="onlyTag" class="kjwt-item" :href="url" :data-space="data.speaceId" :data-material="data.id" target="_blank" rel="sponsored" v-else-if="data && type == 1">
    <img class="kjwt-image" :src="imgSrc" />
  </a>

  <!-- 文字广告 -->
  <a
    :data-space="data.speaceId" :data-material="data.id"
    rel="sponsored"
    :id="onlyTag"
    class="kjwt-item kjwt-text e"
    :style="{ color: fontColor, fontWeight }"
    :href="url"
    target="_blank"
    v-else-if="data && type == 2"
  >
    <!-- 文字广告 -->
    <span v-html="text"></span>
  </a>

  <!-- 代码广告 -->
  <iframe
    :data-space="data.speaceId" :data-material="data.id"
    :id="onlyTag"
    class="kjwt-item"
    frameborder="0"
    scrolling="no"
    :src="codeURL"
    v-else-if="data && type == 3"
    :style="{ width: `${width}px`, height: `${height}px` }"
  ></iframe>
</template>
<script>
import {getRandomItems} from '@/utils/utils'
export default {
  name: 'ItemAdv',
  props: { data: Object },
  created(){
    /* if(this.data && this.data.showType == 3){

      console.log('单个广告数据---->',this.data)
    } */
  },
  methods:{
    randomItems(data){
      return getRandomItems(data,data.length);
    }
  },
  computed: {
    // 广告类型, 1图片广告 2文字广告 3代码广告  4信息流广告
    type() {
      return this.data.type;
    },
    // 代码广告ID
    code() {
      return this.data.code;
    },
    // 代码广告地址
    codeURL() {
      return `/crm/inventory/get/${this.data.id}`;
    },
    // 图片广告地址
    imgSrc() {
      return this.data.imgSrc;
    },
    // 文字广告内容
    text() {
      return this.data.text;
    },
    // 广告链接
    url() {
      return this.data.url;
    },
    // 图片广告显示方式 1独显 2轮显 3轮播
    showType() {
      return this.data.showType;
    },
    // 轮播列表
    list() {
      return this.data.list;
    },
    // 字体加粗
    fontWeight() {
      return this.data.fontWeight ? 600 : 400;
    },
    // 字体颜色
    fontColor() {
      return this.data.fontColor || '#000';
    },
    width() {
      return this.data.width;
    },
    height() {
      return this.data.height;
    },
    onlyTag(){
      return `kjwt-item-${this.data.speaceId}-${this.data.id}`;
    }
  },
};
</script>
<style lang="less" scoped>
.kjwt-item {
  display: block;
}
.kjwt-image {
  display: block;
}
.kjwt-text {
  font-size: 16px;
  line-height: 28px;
  color: var(--text-color);
  &:hover {
    span {
      color: var(--primary-color);
    }
  }
}
</style>
